import React from "react";

// CTA Button Component
const CTAButton = () => {
  const handleClick = () => {
    const aboutSection = document.getElementById("about");
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: "smooth" }); // Smooth scroll allowed
    }
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      className="bg-[#4199db] rounded-[15px] h-12 sm:h-[56px] w-full sm:w-[280px] relative cursor-pointer flex items-center justify-center shadow-lg hover:bg-blue-700 text-white font-poppins"
    >
      <div className="flex items-center gap-3 relative z-10">
        <span className="text-base sm:text-[20px] font-normal">Learn more</span>
        <svg
          className="w-5 h-5 text-white"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M7 17l9.2-9.2M17 17V7H7" />
        </svg>
      </div>
    </button>
  );
};

// Dark Info Box Component
const DarkInfoBox = () => (
  <div className="relative h-40 sm:h-[350px] w-full sm:w-[550px] flex flex-col items-center justify-center p-8">
    {/* Border frame */}
    <div className="absolute inset-0 rounded-2xl sm:rounded-b-none sm:rounded-tr-2xl border border-gray-300 z-0" />
    {/* White background */}
    <div className="absolute inset-0 bg-white rounded-2xl sm:rounded-b-none sm:rounded-tr-2xl shadow-xl z-0" />
    <p className="text-gray-800 text-base sm:text-lg font-medium font-poppins text-center leading-relaxed max-w-xs sm:max-w-[450px] z-10">
      Our strength lies in expert experience, understanding trends, the ability
      to listen to our clients, and quickly immersing ourselves in the specifics
      of their business.
    </p>
  </div>
);

// Hero Content Component
const HeroContent = () => (
  <div className="flex flex-col gap-6 sm:gap-10 ml-0 sm:ml-[20px] max-w-full sm:max-w-[700px] pt-20 sm:pt-32 items-center sm:items-start text-center sm:text-left">
    <div className="flex flex-col gap-4 sm:gap-8">
      <h1 className="text-3xl sm:text-[56px] font-extrabold font-poppins leading-tight text-center sm:text-left mb-2 text-gray-800">
        <span className="text-xxl block">Transforming challenges</span>
        <span className="text-xxl block mt-1">into opportunities</span>
      </h1>
      <p className="text-lg font-normal font-poppins leading-relaxed text-gray-800">
        We provide expert consulting, helping businesses optimize processes and
        achieve goals.
      </p>
    </div>
    <div className="flex justify-center sm:justify-start ml-0 sm:ml-8 w-full p-10">
      <CTAButton />
    </div>
  </div>
);

// Main Hero Component
const Hero = () => {
  return (
    <section className="relative min-h-[80vh] flex flex-col items-center sm:items-start justify-center px-4 sm:px-16 pt-8 sm:pt-0 overflow-hidden bg-white">
      <div className="w-full z-10">
        <div className="flex-1 flex flex-col items-center sm:items-start w-full z-10">
          <HeroContent />
        </div>

        {/* Info box: bottom right on desktop */}
        <div className="hidden sm:flex w-full justify-center sm:block">
          <div className="sm:absolute sm:bottom-0 sm:right-0">
            <DarkInfoBox />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
